import { isLocale } from "@snubes/snubes-types";
import { I18N_SETTINGS } from "../consts/I18N_SETTINGS";

export function parseLocale(param: string | string[] | undefined) {
  if (param !== "_next" && isLocale(param)) {
    return param;
  }
  return I18N_SETTINGS.fallbackLng;
}
